import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function FinalCtaSection() {
  return <section data-section-id="256128" id="final-cta-section" className="bg-primary text-primary-foreground py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[40rem] h-[30rem] bg-secondary/10 blur-[120px] rounded-lg" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-primary-foreground mb-6 tracking-tight">
            Ready to Protect Your Home? Get Your Free Plan Today
          </h2>
          
          <p className="text-lg md:text-xl text-primary-foreground/90 mb-4 max-w-2xl font-default font-light">
            Get your free professional assessment today. Most homeowners save 20% by comparing quotes first.
          </p>
          <p className="text-base md:text-lg text-secondary font-default font-medium mb-10">
            Appointments available within 48 hours
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <Button size="lg" asChild className="w-full sm:w-auto rounded-md text-base h-12 px-8 shadow-md bg-secondary text-secondary-foreground hover:bg-secondary/90">
              <Link to="/ContactPage">
                Request Your Free Comparison Estimate
                <ArrowRight className="ml-2 size-4" />
              </Link>
            </Button>
            
            <Button variant="outline" size="lg" asChild className="w-full sm:w-auto rounded-md text-base h-12 px-8 border-primary-foreground/40 text-primary-foreground hover:bg-primary-foreground hover:text-primary">
              <Link to="/ContactPage">
                Call Now
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}